import { useNavigate } from "react-router-dom";

import { ABOUT_ROUTES, PATHS } from "../../../config/routeConfig";
import { useVulnerabilityContext } from "../../../context/vulnerability/useVulnerabilityContext";
import { questionContent } from "../questions";
import MultipleChoiceQuestion from "../../../components/Questions/MultipleChoiceQuestion";
import { CustomerSupportVulnerabilityCircumstanceChronicIllnessInput } from "../../../generated/customer/schema.graphql";

type ChronicIllnessQuestionRecord = Record<
  keyof CustomerSupportVulnerabilityCircumstanceChronicIllnessInput,
  string
>;

type ChronicIllnessQuestion = Omit<
  ChronicIllnessQuestionRecord,
  "neurologicalDisorders"
>;

export const chronicQuestions: ChronicIllnessQuestion = {
  cancer: "Cancer",
  cardiovascularDisease: "Cardiovascular Disease",
  chronicRespiratoryDiseases: "Chronic Respiratory Disease",
  copd: "COPD (e.g. Emphysema, Chronic Bronchitis)",
  diabetes: "Diabetes",
  kidneyDisease: "Kidney Disease",
  liverDisease: "Liver Disease",
  organFailure: "Organ failure (e.g. heart, kidney, liver)",
  other: "Other serious chronic illness",
};

const ChronicIllnessDetail: React.FC = () => {
  const { answers, setAnswers } = useVulnerabilityContext();
  const navigate = useNavigate();

  const content = questionContent.chronicIllnessDetail;

  const onChange = (newAnswers: Record<string, boolean>) => {
    setAnswers({
      ...answers,
      chronicIllnessDetail: newAnswers,
    });
  };

  const onContinue = () => {
    navigate(`/${PATHS.About}/${ABOUT_ROUTES.Financial}`);
  };

  return (
    <MultipleChoiceQuestion
      options={chronicQuestions}
      step={content.step}
      title={content.title}
      subTitle={content.subTitle}
      whyWeWantTexts={content.whyWeWantTextsCustomer}
      onChange={onChange}
      onContinue={onContinue}
      values={answers.chronicIllnessDetail}
      requireAnswer
    />
  );
};

export default ChronicIllnessDetail;
